import { useEffect, useRef, useState } from "react";
import type { FreshValueProps } from "./types";

const FLASH_MS = 1400;

export const FreshValue = ({ valueKey, children, className = "" }: FreshValueProps) => {
  const previousKey = useRef(valueKey);
  const [isFresh, setIsFresh] = useState(false);

  useEffect(() => {
    if (previousKey.current === valueKey) return;
    previousKey.current = valueKey;
    if (valueKey === null) return;
    setIsFresh(true);
    const timer = window.setTimeout(() => setIsFresh(false), FLASH_MS);
    return () => window.clearTimeout(timer);
  }, [valueKey]);

  return (
    <span
      data-fresh={isFresh || undefined}
      className={`rounded px-1 transition-colors duration-700 ${
        isFresh ? "bg-emerald-200/80 ring-1 ring-emerald-400" : "bg-transparent ring-0"
      } ${className}`}
    >
      {children}
    </span>
  );
};
